import { render } from "./MobileSubpageHeader.vue?vue&type=template&id=f2e1974a&scoped=true"
import script from "./MobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./MobileSubpageHeader.vue?vue&type=script&lang=js"

import "./MobileSubpageHeader.vue?vue&type=style&index=0&id=f2e1974a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e1974a"]])

export default __exports__